import React from 'react'
import styles from './linkShowcase.module.css';
import ExportIcon from '../../../../../Components/Icons/exportIcon';

export const LinkShowcase = ({ linkUrl, linkText }: { linkUrl: string, linkText: string }) => {
    return (
        <a className={styles.linkShowcase} href={linkUrl} target="_blank" rel="noopener noreferrer">
            <span className={styles.linkText}>{linkText}</span>
            <ExportIcon width={14} height={14} fillColor="#2563EB" />
        </a>
    )
}
